import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76eaa640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"align-self":"center"},
    src: "/images/logos/Logo_Tuvast.png",
    width: "140"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Dashboard", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Documenten", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Account", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Uitloggen", -1))

import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LayoutOutlined, FileOutlined, ToolOutlined, QuestionOutlined, UserOutlined, LogoutOutlined } from '@ant-design/icons-vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  emits: ['closeNav'],
  setup(__props, { emit }) {

const selectedKeys = ref<string[]>([])
const route = useRoute()
const router = useRouter()
const auth = authStore()


watch(() => route.name, () => {
  setActiveRoute()
})

onMounted(() => {
  setActiveRoute()
})

function setActiveRoute () : void {
  if (typeof route.name === 'string') {
    switch (route.name) {
      case 'IssueShow':
      case 'IssueCreate':
      case 'QuestionShow':
      case 'QuestionCreate':
      case 'MessageShow':
        selectedKeys.value = ['Dashboard']
        break
      default:
        selectedKeys.value = [route.name]
    }
  }
}

function navigateTo (navItem:{ key:string }) : void {
  if (route.name !== navItem.key && navItem.key !== 'Logout') {
    const keyboard = window.event as KeyboardEvent
    if (keyboard.ctrlKey) {
      const route = router.resolve({ name: navItem.key })
      window.open(route.href, '_blank')
    } else {
      router.push({ name: navItem.key })
    }
    emit('closeNav')
  }
}

function logout () : void {
  auth.logout()
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_menu, {
      class: "sidebar-navigation",
      mode: "inline",
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
      onClick: navigateTo
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_menu_item, { key: "Dashboard" }, {
          default: _withCtx(() => [
            _createVNode(_unref(LayoutOutlined)),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, { key: "Documents" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FileOutlined)),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, { key: "Account" }, {
          default: _withCtx(() => [
            _createVNode(_unref(UserOutlined)),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, {
          key: "Logout",
          onClick: _withModifiers(logout, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LogoutOutlined)),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["selectedKeys"])
  ]))
}
}

})